export enum CoachingCardRep {
    EXPAND_CLICK = 'coachingCardRep.expandClick',
    RELOAD_CLICK = 'coachingCardRep.reloadClick',
    NAVIGATE_CLICK = 'coachingCardRep.navigateClick',
    METRIC_CLICK = 'coachingCardRep.metricClick',
    SORT_CLICK = 'coachingCardRep.sortClick',
    ACCORDION_TOGGLE_CLICK = 'coachingCardRep.accordionToggleClick',
    SHOW_MORE_TOGGLE_CLICK = 'coachingCardRep.showMoreToggleClick',
}
